var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlandsbanken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-12 -12 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 29v-.058H17.936c2.164-4.093.228-.346 2.278-4.266H8.598c-1.993 3.748-.228.404-2.278 4.266-6.32 0-.057.058-6.32 0 8.2-15.45 0-.057 8.256-15.45L5.58 9.17h14.292A5988.738 5988.738 0 0 1 32 29zm-15.203-9.109c.057-.057-.114-.288-2.904-4.958-2.562 4.612-.228.346-2.733 4.958h5.637zM9.224 7.44c-2.562-4.266 0 0-2.676-4.439h9.509c2.733 4.381.114.173 2.79 4.439H9.224z",
    fill: "#00633A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlandsbanken);
export default __webpack_public_path__ + "static/media/alandsbanken.6b9a34a6ef42b8c1d5deea0c30e5117f.svg";
export { ForwardRef as ReactComponent };